// extracted by mini-css-extract-plugin
export default {"container":"Bp-z","brandName":"Cp-z","productName":"Dp-z","productNamePdpEnhancements":"Ep-z","breakLongProductName":"Fp-z"};